"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
var _DivisionFees = _interopRequireDefault(require("./DivisionFees"));
var _DivisionRaceStartDays = _interopRequireDefault(require("./DivisionRaceStartDays"));
var _DivisionFlags = _interopRequireDefault(require("./DivisionFlags"));
var _DivisionDetail = _interopRequireDefault(require("./DivisionDetail"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
var _ref2 = /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement("p", {
  className: "pull-xs-right"
}, "Non-Ranking"));
class Division extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (value, field) => {
      this.props.onUpdate(this.props.competitionDivision.id, field, value);
    });
  }
  // *******************************************************************************
  // Render
  // *******************************************************************************

  render() {
    const division = this.props.competitionDivision;
    const competitionID = this.props.competitionID;
    const yearID = this.props.yearID;
    const user = this.props.user;
    if (!this.props.loaded) return _ref;
    return /*#__PURE__*/_react.default.createElement("div", null, division.isRanking ? null : _ref2, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 12,
      md: 6,
      lg: 12,
      xl: 6
    }, /*#__PURE__*/_react.default.createElement(_DivisionFlags.default, {
      user: this.props.user,
      division: division,
      competitionID: competitionID,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: 12,
      md: 6,
      lg: 12,
      xl: 6
    }, /*#__PURE__*/_react.default.createElement(_DivisionRaceStartDays.default, {
      user: this.props.user,
      division: division,
      competitionDays: this.props.competitionDays,
      onChange: this._onChange
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_DivisionDetail.default, {
      competitionID: competitionID,
      user: user,
      division: division,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block",
      style: {
        borderTop: '1px solid rgba(0,0,0,0.125)'
      }
    }, /*#__PURE__*/_react.default.createElement(_DivisionFees.default, {
      competitionID: competitionID,
      yearID: yearID,
      user: user,
      division: division,
      onChange: this._onChange
    })));
  }
  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Division, "partials", {
  Divisions: _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
    id: true,
    isRanking: true
  }, _DivisionFees.default.partials.Division), _DivisionRaceStartDays.default.partials.Division), _DivisionFlags.default.partials.Division), _DivisionDetail.default.partials.Division),
  CompetitionDays: _mergeBqlQueries({}, _DivisionRaceStartDays.default.partials.CompetitionDays)
});
var _default = exports.default = (0, _reactBicycle.connect)(Division, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('CompetitionDivision.set', {
      id,
      field,
      value
    });
  },
  onAddFeeAdjustment(competitionDivisionID, feeAdjustmentRef) {
    return client.update('DivisionFeeAdjustment.create', {
      competitionDivisionID,
      feeAdjustmentRef
    });
  }
}));